import { createAction } from 'typesafe-actions';

import { desktopActions } from '../constants/DesktopApp';

interface GenerateAndGoToBranchLinkParams {
  deepLinkData: $TSFixMe;
  deepLinkSourcePath: $TSFixMe;
}

export const generateAndGotoBranchLink = createAction(
  desktopActions.GENERATE_AND_GO_TO_BRANCH_LINK,
  ({ deepLinkData, deepLinkSourcePath }: GenerateAndGoToBranchLinkParams) => ({
    deepLinkData,
    deepLinkSourcePath,
  }),
)<GenerateAndGoToBranchLinkParams>();

export type GenerateAndGotoBranchLinkAction = ReturnType<typeof generateAndGotoBranchLink>;
